import { getRequest, postRequest, putRequest } from '.'

export const getOptions = async (): Promise<
  wowaudit.NotificationTemplateOption[]
> => {
  return await getRequest(`/api/notification_template_options`)
}

export const getTemplates = async (
  teamId: number,
): Promise<wowaudit.NotificationTemplate[]> => {
  return await getRequest(`/api/teams/${teamId}/notification_templates`)
}

export const getTemplateBlacklists = async (): Promise<{
  blacklists: wowaudit.NotificationTemplateBlacklist[]
  teams: wowaudit.Team[]
  types: string[]
}> => {
  return await getRequest(`/api/user/notification_template_blacklists`)
}

export const getDiscordChannelDetails = async (
  addresses: string[],
): Promise<wowaudit.DiscordChannelDetails[]> => {
  return await getRequest(
    `/api/discord_channel_details?addresses[]=${addresses
      .map((address) => encodeURIComponent(address))
      .join('&addresses[]=')}`,
  )
}

export const getNotifications = async (
  teamId: number,
): Promise<wowaudit.Notification[]> => {
  return await getRequest(`/api/teams/${teamId}/notifications`)
}

export const sendTestMessage = async (
  templateId: number,
  teamId: number,
): Promise<{ success: boolean; notification_id: number | null }> => {
  return await postRequest(
    `/api/teams/${teamId}/notification_templates/${templateId}/test`,
    {},
  )
}

export const awaitPendingMessage = (
  teamId: number,
  notificationId: number,
  callback: (result: Partial<wowaudit.Notification>) => void,
) => {
  setTimeout(async () => {
    try {
      const notification: wowaudit.Notification = await getRequest(
        `/api/teams/${teamId}/notifications/${notificationId}`,
      )

      if (notification.deliveryStatus === 'pending') {
        awaitPendingMessage(teamId, notificationId, callback)
      } else {
        callback(notification)
      }
    } catch {
      callback({ deliveryStatus: 'failed', errorStatus: 'Unknown error' })
    }
  }, 1000)
}

export const updateNotification = async (
  notificationId: number,
  teamId: number,
  deliveryStatus: 'pending' | 'abandoned',
): Promise<{ success: boolean }> => {
  return await putRequest(
    `/api/teams/${teamId}/notifications/${notificationId}`,
    { deliveryStatus },
  )
}
